export enum CommentRelation {
  Owner = 'Owner',
  Replied = 'Replied',
  Watching = 'Watching',
}
